import { render, staticRenderFns } from "./new_phase_dialog.vue?vue&type=template&id=4f055b31&scoped=true&"
import script from "./new_phase_dialog.vue?vue&type=script&lang=js&"
export * from "./new_phase_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f055b31",
  null
  
)

export default component.exports